import { Modal } from "react-bootstrap";
import styledComponents from "styled-components";

const Styled = styledComponents.div`
.modal-header {
    display:none !important;
}

.modal-header.show-close {
    display: flex !important;
}

.modal-header.show-close .btn-close-custom {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    color: var(--color-primary);
    font-size: 1.2rem;
    cursor: pointer;
    z-index: 1000;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.modal-header.show-close .btn-close-custom:hover {
    color: color-mix(in srgb, var(--color-primary) 80%, black);
    background-color: var(--color-primary-soft);
    transform: scale(1.1);
}

/* Scrollable modal body support */
.modal-body-scrollable {
    max-height: 70vh !important;
    overflow-y: auto !important;
}

.modal-body-scrollable .modal-content-wrapper {
    max-height: 70vh;
    overflow-y: auto;
}

`;

export const ModalCompAdvance = ({
  show,
  handleClose,
  modalTitle,
  modalBody = 0,
  close,
  footerClose,
  size,
  centered,
  designClass,
  arrayComp = [],
}) => {
  const showFooterClose = footerClose ?? close;
  // console.log(arrayComp[0],'arrayComp')
  return (
    <Styled>
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          centered={centered}
          size={size}
          aria-labelledby={"example-modal-sizes-title-sm"}
        >
          {close && (
            <Modal.Header className="show-close border-0 pb-0">
              <button
                type="button"
                className="btn-close-custom"
                onClick={handleClose}
                aria-label="Close"
              >
                <span aria-hidden="true" style={{ fontSize: "1.35rem", lineHeight: 1 }}>
                  &times;
                </span>
              </button>
            </Modal.Header>
          )}
          {modalTitle && <Modal.Title>{modalTitle}</Modal.Title>}
          <Modal.Body className={`${designClass} px-lg-4`}>
            {arrayComp[modalBody]?.component}
          </Modal.Body>
          {showFooterClose && (
            <Modal.Footer className="border-0 pt-0 px-lg-4 pb-3 justify-content-end">
              <button
                type="button"
                className="btn btn-sm px-4 py-2 rounded"
                style={{
                  border: "2px solid var(--color-primary)",
                  color: "var(--color-primary)",
                  background: "#fff",
                  minWidth: "120px",
                }}
                onClick={handleClose}
              >
                Close
              </button>
            </Modal.Footer>
          )}
        </Modal>
      </div>
    </Styled>
  );
};

export const ModalCompAdvanceUpdate = ({
  show,
  handleClose,
  modalTitle,
  close,
  size,
  centered,
  designClass,
  arrayComp = [],
  pageName,
}) => {
  // console.log(arrayComp[0],'arrayComp')
  return (
    <Styled>
      <div>
        <Modal
          show={!!pageName}
          onHide={handleClose}
          centered={centered}
          size={size}
        >
          {close && (
            <Modal.Header className="show-close border-0 pb-0">
              <button
                type="button"
                className="btn-close-custom"
                onClick={handleClose}
                aria-label="Close"
              >
                <span aria-hidden="true" style={{ fontSize: "1.35rem", lineHeight: 1 }}>
                  &times;
                </span>
              </button>
            </Modal.Header>
          )}
          {modalTitle && <Modal.Title>{modalTitle}</Modal.Title>}
          <Modal.Body className={`${designClass} px-lg-4`}>
            {arrayComp?.find((item) => item?.name === pageName)?.component}
          </Modal.Body>
          {close && (
            <Modal.Footer className="border-0 pt-0 px-lg-4 pb-3 justify-content-end">
              <button
                type="button"
                className="btn btn-sm px-4 py-2 rounded"
                style={{
                  border: "2px solid var(--color-primary)",
                  color: "var(--color-primary)",
                  background: "#fff",
                  minWidth: "120px",
                }}
                onClick={handleClose}
              >
                Close
              </button>
            </Modal.Footer>
          )}
        </Modal>
      </div>
    </Styled>
  );
};

export const PageSwitch = ({ pageArray = [], pageNumber, pageName }) => {
  return pageNumber
    ? pageArray[pageNumber]?.component
    : pageArray.find((item) => item?.name === pageName)?.component;
};
